<template>
	<b-container class="py-5 pt-xl-0">
		<h5 class="text-center text-bold">
			PAC
		</h5>
		<br>
    <div v-if="!pac">
      <b-alert show>
        <div class="h1 mx-auto text-center mt-4 mb-5">
          <font-awesome-layers class="fa-2x">
            <font-awesome-icon :icon="['fas', 'circle']" :style="{ color: 'white' }" />
            <font-awesome-icon :icon="['fad', 'building-columns']" transform="shrink-6" />
          </font-awesome-layers>
          <font-awesome-icon :icon="['fad', 'arrow-right']" size="1x" class="mx-4 my-2" />
          <font-awesome-layers class="fa-2x">
            <font-awesome-icon :icon="['fas', 'circle']" :style="{ color: 'white' }" />
            <font-awesome-icon :icon="['fad', 'browser']" transform="shrink-6" />
          </font-awesome-layers>
        </div>
        Aquí puedes conectar la cuenta de tu banco mediante PAC (pago automático en cuenta corriente) para facilitar los distintos pagos de tu compra, para realizarlo es necesario presionar este botón: <br />
        <b-button block squared variant="success" class="mt-5 mt-sm-5 mb-2" type="button" @click="addFintoc()" :disabled="contract_id == null">Agregar PAC</b-button>
      </b-alert>
      <b-overlay rounded="lg" spinner-variant="gold">
        <b-row style="width: 100%;" class="content-card">
          <b-col>
            <b-table-simple condensed borderless hover>
            </b-table-simple>
          </b-col>
        </b-row>
      </b-overlay>
    </div>
    <div v-else >
      <b-row>
        <b-col>
          <b-alert show>Esta es la cuenta PAC del banco {{ getBank(pac.institution_id).name }} que tienes asignada con nosotros. Esta cuenta será la encargada de pagar de forma automatizada todo lo perteneciente a tu plan de pagos en base a las fechas pactadas. Tus pagos pueden tardar entre 48 a 72 en ser efectivos. </b-alert>
          <b-card no-body class="overflow-hidden" style="max-width: 800px;">
            <b-row no-gutters>
              <b-col md="5" align-self="center">
                <b-card-img class="rounded" :src="getBank(pac.institution_id).img"/>
              </b-col>
              <b-col md="7" class="px-3">
                <b-card-body title="Información del PAC">
                  <b-card-text>
                    <b-table-simple condensed bordered hover>
                      <b-tbody>
                        <b-tr>
                          <b-td>Nombre</b-td>
                          <b-td>{{ pac.holder_name }}</b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>Banco</b-td>
                          <b-td>{{ pac.institution_name }}</b-td>
                        </b-tr>
                        <b-tr v-if="pac.official_name">
                          <b-td>Cuenta</b-td>
                          <b-td>{{ pac.official_name }}</b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>Numero de Cuenta</b-td>
                          <b-td>{{ pac.number }}</b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>Numero de PAC</b-td>
                          <b-td>{{ pac.holder_id }}</b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>Fecha de creación</b-td>
                          <b-td>{{ parseDate(pac.created_at) }}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-card-text>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <WidgetFintoc v-if="showWidget" @showWidget="showWidgetAction"  @dataResultWidget="resultSuccessWidget" :project_id="this.apartment.project_id" ></WidgetFintoc>
	</b-container>
</template>
<script>
	import WidgetFintoc from './WidgetFintoc.vue'

	export default {
		name: "payments",
    emits: ['showWidget', 'dataResultWidget'],
		components: {
      WidgetFintoc
		},
		props: {
			asset_id: null,
			project_id: {default: null},
      response_pac: {default: null},
		},
		data() {
			return {
				customStyles: {
					li: {
						display: 'inline-block',
					},
					a: {
						color: 'black'
					}
				},
				customLabels: {
					first: '<<',
					last: '>>',
					previous: '<',
					next: '>'
				},
				pageOfItems: [],
				loading: true,
        showWidget: false,
        pac: null
			}
		},
    computed: {
      contract_id(){
				return this.$store.getters.getContractId == undefined ? null : this.$store.getters.getContractId
			},
      apartment() {
				return this.$store.getters.getApartmentById(parseInt(this.asset_id));
			},
    },
    beforeMount() {
    },
    created(){
      if(this.response_pac != null)
        this.pac = this.response_pac;
    },
		methods: {
      getBank(){
        if (this.pac.institution_id == 'cl_banco_santander')
          return {name: 'Santander', img: require('@/assets/images/banks/Santander.png') }
        else if (this.pac.institution_id == 'cl_banco_de_chile')
          return {name: 'Chile', img: require('@/assets/images/banks/Chile.png') }
        else if (this.pac.institution_id == 'cl_banco_scotiabank')
          return {name: 'Scotiabank', img: require('@/assets/images/banks/Scotiabank.png') }
        else if (this.pac.institution_id == 'cl_banco_itau')
          return {name: 'Itau', img: require('@/assets/images/banks/Itau.png') }
        else if (this.pac.institution_id == 'cl_banco_bci')
          return {name: 'BCI', img: require('@/assets/images/banks/Bci.png') }
        else if (this.pac.institution_id == 'cl_banco_falabella')
          return {name: 'Falabella', img: require('@/assets/images/banks/Falabella.png') }
        else if (this.pac.institution_id == 'cl_banco_estado')
          return {name: 'Estado', img: require('@/assets/images/banks/Estado.png') }
      },
			addFintoc(){
        this.showWidget = true
      },
      showWidgetAction(stateWidget){
        this.showWidget = stateWidget
      },
      resultSuccessWidget(response){
        this.pac = response.data
      },
      getPacs(){
        this.axios.get(`payments/get_fintoc_pacs?contract_id=${this.contract_id}`).then(result => {
          this.pac = result.data
        }).catch(error => {
          console.log(error)
        })
      },
      parseDate(date){
        return this.$moment(date).format("DD-MM-YYYY")
      },
		},
    watch: {
      contract_id: function (new_val) {
        if (new_val)
          this.getPacs()
      },
    }
	};
</script>
<style scoped>
.margin-10 {
	margin-top:10
}
</style>
